import React from 'react'
import DoubtAnswered from './components/DoubtAnswered'
import HomeHeader from '../../components/HomeHeader'
import Footer from '../../components/Footer'
import { RouteComponentProps } from 'react-router-dom'

interface RouteParams {
  doubt?: string
  number?: string
}

type DoubtProps = RouteComponentProps<RouteParams>

const Doubt: React.FC<DoubtProps> = ({
  match: {
    params: { doubt, number },
  },
}) => {
  return (
    <>
      <HomeHeader />
      <DoubtAnswered query={doubt ?? ''} number={number} />
      <Footer />
    </>
  )
}

export default Doubt
